(function () {
  angular.module("akitabox.ui.dialogs.schedule.editFrequency", [
    "ngMaterial",
    "akitabox.core.services.schedule",
    "akitabox.core.services.timeZone",
  ]);
})();
